import Raven from 'raven-js'

export function setUserContext ({profile}) {
  try {
    Raven.setUserContext({
      id: profile.id,
      email: profile.email,
      first_name: profile.first_name,
      last_name: profile.last_name,
      selected_outlets: profile.selected_outlets
    })
  } catch (error) {
    console.log('Invalid JSON from getProfile' + JSON.stringify(profile))
  }
}



// WEBPACK FOOTER //
// ./app/sentry/login.js